import React from "react";
import { Container } from "./common/Container";
import DemoImg from "../assets/about/main.webp";
import ImgOne from "../assets/about/imgOne.webp";
import ImgTwo from "../assets/about/imgTwo.webp";
import ImgThree from "../assets/about/IMG_3825.webp";
import ImgFour from "../assets/about/four.jpg";

function Gallery() {
  return (
    <div>
      <div
        className="mx-auto w-full px-8 py-[120px]"
        style={{
          backgroundImage: `linear-gradient(20deg, #082635, rgba(0,0,0,0.1)), url(${DemoImg})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <h2 className="mb-[70px] text-center text-[30px] font-bold text-white sm:text-[40px] lg:mb-[100px]">
          Explore Our Gallery
        </h2>
        <Container>
          <div
            className="xl:grid-cols- grid grid-cols-2 gap-4 px-14 sm:grid-cols-2 lg:grid-cols-4"
            data-aos="fade-up"
          >
            {/* Image 1 */}
            <div className="group relative aspect-auto -translate-y-3 rotate-6 transform overflow-hidden rounded-2xl border-[7px] border-orange-300">
              <img
                src={ImgOne}
                alt="Gallery item 1"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            {/* Image 2 */}
            <div className="group relative aspect-auto translate-y-3 -rotate-6 transform overflow-hidden rounded-2xl border-[7px] border-orange-300">
              <img
                src={ImgTwo}
                alt="Gallery item 2"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            {/* Image 1 */}
            <div className="group relative aspect-auto -translate-y-3 rotate-6 transform overflow-hidden rounded-2xl border-[7px] border-orange-300">
              <img
                src={ImgThree}
                alt="Gallery item 1"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            {/* Image 2 */}
            <div className="group relative aspect-auto translate-y-3 -rotate-6 transform overflow-hidden rounded-2xl border-[7px] border-orange-300">
              <img
                src={ImgFour}
                alt="Gallery item 2"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Gallery;
